exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block-children {\n  font-size: 16px;\n  color: var(--text-title);\n  color: var(--text-title);\n}\n", ""]);

// exports
